import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';

class NetworkPointDetailsOperatorInfoMarketComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public loggedInUser: any;
    public marketExpanded: boolean = true;
    public networkPoint: NetworkPointDto;
    public form: any;

    public tradingMarket: AvailableTradingMarket[] = ['PRIMARY', 'SECONDARY'];
    private possibleMarketAreas: string[] = [];

    public possibleSellingMethods: SellingMethod[] = [
        'AUCTION_SHORT_TERM',
        'AUCTION_LONG_TERM',
        'FCFS_REGULAR',
        'FCFS_DIRECT',
        'SECONDARY_CFO',
        'SECONDARY_FCFS',
        'SECONDARY_OTC'
    ];

    public sellingMethodsValidationErrors: string[] = [];
    private tradingMarketTouched = false;
    private sellingMethodTouched = false;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private $scope: ng.IScope
    ) {}

    $onInit(): void {
        if (!this.networkPoint.tradingMarkets0) {
            this.networkPoint.tradingMarkets0 = [];
        }
        this.validateTradingMarkets();
        if (!this.networkPoint.sellingMethods0) {
            this.networkPoint.sellingMethods0 = [];
        }
        this.validateSellingMethods();
        if (this.isCreateMode) {
            this.getMarketAreas();
        } else if (this.isEditMode) {
        }

        this.$scope.$watch(
            () => this.networkPoint.tradingMarkets0,
            () => this.validateSellingMethods(),
            true
        );

        // if (!this.isEditMode) {
        //    this.networkPoint.tradingMarkets0 = angular.copy(this.tradingMarket);
        // }
    }

    private getMarketAreas(): void {
        this.TransmissionSystemOperator.queryMarketAreaNotifications(
            { id: this.loggedInUser.referenceId },
            (res: MarketAreaAssignmentDto[]) => {
                angular.forEach(res, (marketArea) => {
                    this.possibleMarketAreas.push(
                        marketArea.marketAreaCoordinatorName
                    );
                });
            }
        );
    }

    public addRemoveTradingMarket(
        add: boolean,
        market: AvailableTradingMarket
    ) {
        if (add) {
            if (this.networkPoint.tradingMarkets0.indexOf(market) == -1) {
                this.networkPoint.tradingMarkets0.push(market);
            }
        } else {
            this.networkPoint.tradingMarkets0.splice(
                this.networkPoint.tradingMarkets0.indexOf(market),
                1
            );
        }
        this.tradingMarketTouched = true;
        this.validateTradingMarkets();
    }

    get showTradingMarketsErrors() {
        return (
            (this.form.$submitted || this.tradingMarketTouched) &&
            !!this.form.$error.tradingMarkets
        );
    }

    public validateTradingMarkets() {
        this.form.$setValidity(
            'tradingMarkets',
            this.networkPoint.tradingMarkets0.length > 0
        );
    }

    public addRemoveSellingMethod(action, sellingMethod: SellingMethod) {
        const idx = this.networkPoint.sellingMethods0.indexOf(sellingMethod);
        if (action) {
            if (idx == -1) {
                this.networkPoint.sellingMethods0.push(sellingMethod);
            }
        } else {
            this.networkPoint.sellingMethods0.splice(idx, 1);
        }
        this.sellingMethodTouched = true;
        this.validateSellingMethods();
    }

    get showSellingMethodsErrors() {
        return (
            (this.form.$submitted || this.sellingMethodTouched) &&
            !!this.form.$error.sellingMethods
        );
    }

    public validateSellingMethods() {
        this.sellingMethodsValidationErrors = [];

        if (!this.networkPoint.sellingMethods0) return;

        if (this.networkPoint.sellingMethods0.length === 0) {
            this.sellingMethodsValidationErrors.push(
                `None of the 'Selling methods' is selected.`
            );
        } else {
            const selected = new Set<SellingMethod>(
                this.networkPoint.sellingMethods0
            );
            const tradingMarkets = new Set<AvailableTradingMarket>(
                this.networkPoint.tradingMarkets0 || []
            );
            if (selected.has('FCFS_DIRECT') && selected.has('FCFS_REGULAR')) {
                this.sellingMethodsValidationErrors.push(
                    `Cannot select both 'Regular FCFS' and 'Direct FCFS'.`
                );
            }

            if (
                selected.has('AUCTION_LONG_TERM') &&
                !(tradingMarkets.has('ALL') || tradingMarkets.has('PRIMARY'))
            ) {
                this.sellingMethodsValidationErrors.push(
                    `'Long Term Auction' requires 'Primary' trading market.`
                );
            }

            if (
                selected.has('AUCTION_SHORT_TERM') &&
                !(tradingMarkets.has('ALL') || tradingMarkets.has('PRIMARY'))
            ) {
                this.sellingMethodsValidationErrors.push(
                    `'Short Term Auction' requires 'Primary' trading market.`
                );
            }

            if (
                (selected.has('FCFS_DIRECT') || selected.has('FCFS_REGULAR')) &&
                !(tradingMarkets.has('ALL') || tradingMarkets.has('PRIMARY'))
            ) {
                this.sellingMethodsValidationErrors.push(
                    `'FCFS' requires 'Primary' trading market.`
                );
            }

            if (
                (selected.has('SECONDARY_CFO') ||
                    selected.has('SECONDARY_FCFS') ||
                    selected.has('SECONDARY_OTC')) &&
                !(tradingMarkets.has('ALL') || tradingMarkets.has('SECONDARY'))
            ) {
                this.sellingMethodsValidationErrors.push(
                    `'Secondary CFO/FCFS/OTC' requires 'Secondary' trading market.`
                );
            }
        }

        this.form.$setValidity(
            'sellingMethods',
            this.sellingMethodsValidationErrors.length === 0
        );
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoMarket', {
    controller: NetworkPointDetailsOperatorInfoMarketComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-market.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<',
        loggedInUser: '<'
    }
});
